import React from "react";
import { useTranslation } from "react-i18next";
import { AppContext } from "../Store";

// import components
import ListItem from "../components/ListItem";

export default function OpenTickets() {
  const { t } = useTranslation();
  const [state, setState] = React.useContext(AppContext);

  return (
    <>
      <main className={"py-16 px-8"}>
        <h1 className={"text-4xl font-light"}>{t("homeOpenTickets")}</h1>
        <h2 className={"text-sm font-light mb-20"}>
          {t("homeOpenTicketsExp")}
        </h2>

        {state.tickets && state.tickets.open.length > 0 ? (
          Object.keys(state.tickets.open).map((key) => {
            return (
              <ListItem
                type={"open"}
                item={state.tickets.open[key]}
                key={key}
              />
            );
          })
        ) : (
          <p>{t("noTickets")}</p>
        )}
      </main>
    </>
  );
}
